/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from antd/lib/time-picker/index.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import AnimationContext from '../config-provider/AnimationContext';
import { DatePicker } from '../date-picker';
import warning from 'antd/lib/_util/warning';
import { getDropdownClassName } from '../date-picker/generatePicker/_util';
const { TimePicker: InternalTimePicker, RangePicker: InternalRangePicker } = DatePicker;
const RangePicker = React.forwardRef((props, ref) => {
    const { prefixCls: customizePrefixCls, dropdownClassName: customizeDropdownClassName, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const { glassmorphism } = React.useContext(AnimationContext);
    const prefixCls = getPrefixCls('picker', customizePrefixCls);
    const dropdownClassName = classNames({
        [`glassmorphism glassmorphism-dropdown`]: !!glassmorphism
    }, getDropdownClassName(customizeDropdownClassName, prefixCls));
    return (React.createElement(InternalRangePicker, { ...otherProps, dropdownClassName: dropdownClassName, picker: 'time', mode: undefined, ref: ref }));
});
const TimePicker = React.forwardRef((props, ref) => {
    const { addon, renderExtraFooter, dropdownClassName: customizeDropdownClassName, ...restProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const { glassmorphism } = React.useContext(AnimationContext);
    const prefixCls = getPrefixCls('picker', props.prefixCls);
    if (process.env.NODE_ENV !== 'production')
        warning(!('theme' in props), 'TimePicker', '`theme` is deprecated in 3.0.0.');
    const internalRenderExtraFooter = React.useMemo(() => {
        if (renderExtraFooter) {
            return renderExtraFooter;
        }
        if (addon) {
            warning(false, 'TimePicker', '`addon` is deprecated. Please use `renderExtraFooter` instead.');
            return addon;
        }
        return undefined;
    }, [addon, renderExtraFooter]);
    const dropdownClassName = classNames(`${prefixCls}-dropdown-normal`, {
        [`${prefixCls}-bdesign`]: true,
        [`glassmorphism glassmorphism-dropdown`]: !!glassmorphism
    }, customizeDropdownClassName);
    return (React.createElement(InternalTimePicker, { ...restProps, dropdownClassName: dropdownClassName, mode: undefined, ref: ref, renderExtraFooter: internalRenderExtraFooter }));
});
TimePicker.displayName = 'TimePicker';
TimePicker.RangePicker = RangePicker;
export default TimePicker;
// (TimePicker as MergedTimePicker).RangePicker = ConfiguredRangePicker;
// const ConfiguredTimePicker = withConfigProvider(TimePicker) as MergedTimePicker;
// export { ConfiguredTimePicker };
// export default ConfiguredTimePicker;
